import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

export const useRecoveryCode = () => {
  const { authHeader } = useAuth();

  return useMutation((code: any) => {
    return axios.post(
      `${env.verifyServiceUrl}user/two_factor/recover/${code}/`,
      {},
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
